/* Personal Cart previews from bounded properties; no external uploads or analytics. */
(function () {
  'use strict';
  if (window.NLCartPreview) return;
  function render() {
    if (!window.NLPoster) return;
    var config = document.querySelector('[data-nl-cart-config]');
    if (!config) return;
    try { config = JSON.parse(config.textContent); } catch (ignored) { return; }
    document.querySelectorAll('[data-nl-cart-preview]').forEach(function (element) {
      if (element.dataset.rendered && element.__nlProperties === element.dataset.properties && element.querySelector('svg')) return;
      try {
        var properties = JSON.parse(element.dataset.properties);
        if (Array.isArray(properties)) properties = Object.fromEntries(properties);
        // Liquid serializes property values as escaped text, while cart.js returns raw values.
        // Decode one layer in an inert textarea, then let the shared SVG renderer escape again.
        ['_name','_place','Name','Geburtsort','Mjesto rođenja','Birthplace','Zitat','Citat','Quote'].forEach(function (key) {
          var value = properties[key];
          if (typeof value === 'string' && /&(?:amp|lt|gt|quot|#39|#\d+|#x[a-f0-9]+);/i.test(value)) {
            var decoder = document.createElement('textarea');
            decoder.innerHTML = value;
            properties[key] = decoder.value;
          }
        });
        if (properties._style === 'kinderposter' && window.NLKids && window.NLKids.renderCart(element, properties)) return;
        if (properties._style === 'namensposter' && window.NLNames && window.NLNames.cartPreview(element, properties)) return;
        if (properties._style === 'geburtsort' && window.NLPlace && window.NLPlace.cartPreview(element, properties)) return;
        if (properties._style === 'zitatposter' && window.NLQuote && window.NLQuote.cartPreview(element, properties)) return;
        if (properties._style === 'abdruck' && window.NLPrint && window.NLPrint.cartPreview(element, properties)) return;
        var state = window.NLPoster.fromProperties(properties);
        if (!state) {
          if (element.childNodes.length) element.replaceChildren();
          delete element.dataset.rendered;
          var fallback = element.parentElement.querySelector('img.cart-items__media-image');
          if (fallback) fallback.hidden = false;
          return;
        }
        var renderer = new window.NLPoster.PosterSvg(config.forms, config.text, new window.NLPoster.Fmt(properties._locale));
        element.innerHTML = renderer.render(state);
        element.dataset.frame = state.frame;
        element.dataset.rendered = 'true';
        element.__nlProperties = element.dataset.properties;
        var image = element.parentElement.querySelector('img.cart-items__media-image');
        if (image) image.hidden = true;
      } catch (ignored) { /* Existing product image remains the fallback. */ }
    });
    if (window.NLJourney) window.NLJourney.refresh();
  }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; render(); });
  }
  window.NLCartPreview = Object.freeze({render:render});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, {once:true});
  else render();
  document.addEventListener('shopify:section:load', render);
  new MutationObserver(function (records) {
    if (records.some(function (record) {
      if (record.target.nodeType === 1 && record.target.closest('[data-nl-cart-preview]')) return true;
      return Array.from(record.addedNodes || []).concat(Array.from(record.removedNodes || [])).some(function (node) {
        return node.nodeType === 1 && (node.matches('[data-nl-cart-preview]') || node.querySelector('[data-nl-cart-preview]'));
      });
    })) schedule();
  }).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['data-properties']});
})();
